import { Typography } from "@mui/material"
import { AssignmentRecordStudentStatus } from "../../../../types/gqlTypes/graphql"

const ASSIGNMENT_RECORD_STUDENT_STATUS_LABELS: Record<
  AssignmentRecordStudentStatus,
  string
> = {
  NOT_STARTED: "Not Started",
  STARTED: "In Progress",
  COMPLETED: "Completed"
}

export const formatAssignmentRecordStudentStatus = (
  status?: AssignmentRecordStudentStatus | null
) => {
  return status ? ASSIGNMENT_RECORD_STUDENT_STATUS_LABELS[status] : null
}

export const getNameWithNotes = (name: string, notes: string) => {
  return (
    <>
      <Typography variant="body2">{name}</Typography>
      <Typography variant="subtitle2">{notes}</Typography>
    </>
  )
}
